import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=3428b8bb&scoped=true&"
import script from "./trend.vue?vue&type=script&lang=js&"
export * from "./trend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3428b8bb",
  null
  
)

export default component.exports